import { ChevronLeftIcon } from "../../../assets/ChevronLeftIcon";
import { ChevronRightIcon } from "../../../assets/ChevronRightIcon";
import { MONTHS_FR } from "../../utils/leadFormUtils";

export default function DatePickerStep({
  currentMonth,
  firstDay,
  daysInMonth,
  prevMonth,
  nextMonth,
  isDateSelectable,
  selectedDate,
  onSelectDate,
}: {
  currentMonth: Date;
  firstDay: number;
  daysInMonth: number;
  prevMonth: () => void;
  nextMonth: () => void;
  isDateSelectable: (day: number) => boolean;
  selectedDate: Date | null;
  onSelectDate: (date: Date) => void;
}) {
  return (
    <div>
      <div className="tdb-monthNav">
        <button
          type="button"
          onClick={prevMonth}
          className="tdb-iconBtn"
          aria-label="Mois précédent"
        >
          <ChevronLeftIcon className="tdb-navIcon" />
        </button>

        <span className="tdb-monthTitle">
          {MONTHS_FR[currentMonth.getMonth()]} {currentMonth.getFullYear()}
        </span>

        <button
          type="button"
          onClick={nextMonth}
          className="tdb-iconBtn"
          aria-label="Mois suivant"
        >
          <ChevronRightIcon className="tdb-navIcon" />
        </button>
      </div>

      <div className="tdb-grid">
        {Array.from({ length: firstDay }, (_, i) => (
          <div key={`empty-${i}`} />
        ))}

        {Array.from({ length: daysInMonth }, (_, i) => {
          const day = i + 1;
          const selectable = isDateSelectable(day);
          const date = new Date(
            currentMonth.getFullYear(),
            currentMonth.getMonth(),
            day,
          );
          const isSelected =
            selectedDate?.toDateString() === date.toDateString();

          return (
            <button
              type="button"
              key={day}
              disabled={!selectable}
              onClick={() => onSelectDate(date)}
              className={[
                "tdb-dayBtn",
                isSelected ? "is-selected" : "",
                selectable ? "is-selectable" : "is-disabled",
              ].join(" ")}
            >
              {day}
            </button>
          );
        })}
      </div>
    </div>
  );
}
